/**
 * Constants file
 * Usage example:
 * import { constants } from '@/constants/constants'
 */

export const constants = {
  API_BASE_URL: `${import.meta.env.VITE_DEEPSIGN_API_BASE_URL}/v1/`,
  FILE_MAX_SIZE: 40000000,
  FILE_MAX_SIZE_MB: 40,
  ATTACHMENTS_MAX_SIZE_MB: 250,
  ATTACHMENTS_MAX_COUNT: 50,
  ENVELOPE_MAX_FILES: 20,
  DRAWER_WIDTH: '484px',
  DRAWER_WIDTH_TABLET: '444px',
  SESSION_DURATION: 'PT1M',
  SNACKBAR: {
    DURATION: 3000
  },
  EXPAND_SCROLL_OPTIONS: {
    block: 'nearest',
    inline: 'nearest'
  },
  SUPPORTED_AUTOGRAPH_TYPES: ['image/png', 'image/jpeg'],
  SUPPORTED_DOCUMENT_TYPES: [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ],
  SUPPORTED_DOCUMENT_EXTENSIONS: ['pdf', 'docx', 'xlsx'],
  DEEPSIGN_API_HANDLED_ERRORS: [
    'avScan.virusFound',
    'no_subscription_found',
    'subscription_signature_authorization_failed',
    'error.pdf.password.protected',
    'error.pdf.certified.noChangeAllowed',
    'error.pdf.signatureFieldLock.noChangeAllowed',
    'error.pdf.read.failed',
    'error.pdf.unsupported.encryption',
    'error.document.file.tooBig',
    'error.sign.failed',
    'error.sign.user.timeout',
    'error.sign.user.cancel',
    'error.sign.user.password.invalid',
    'error.sign.user.otp.invalid',
    'error.sign.user.serialNumber.mismatch',
    'error.sign.user.onboarding.incomplete',
    'error.sign.document.invalid',
    'error.subscription.failed',
    'error.subscription.observer.unavailable',
    'error.predefined.multiple.signature.fields'
  ],
  SEAL_POLICIES_TO_OMIT: ['canAddSignee', 'canForward', 'canAddObserver'],
  SIGNATURE_SIZE: {
    XS: {
      HEIGHT: 18,
      WIDTH: 35
    },
    S: {
      HEIGHT: 77,
      WIDTH: 146
    },
    M: {
      HEIGHT: 112,
      WIDTH: 212
    },
    L: {
      HEIGHT: 137,
      WIDTH: 260
    }
  },
  SIGNATURE_ASPECT_RATIO: 260 / 137,
  SEAL_ANNOTATION_SIZE: {
    XS: {
      HEIGHT: 8,
      WIDTH: 35
    },
    S: {
      HEIGHT: 20,
      WIDTH: 146
    },
    M: {
      HEIGHT: 30,
      WIDTH: 212
    },
    L: {
      HEIGHT: 50,
      WIDTH: 260
    }
  },
  SIGNING_METHODS: {
    GUEST: 'guest'
  },
  UNTRANSLATED_ERROR_MESSAGES: {
    DOCUMENT_NOT_FOUND: 'Document not found.'
  },
  SIGN_ERRORS_KEY_ORDER: [
    'blocked_country',
    'blocked_nationality',
    'blocked_domicile',
    'unsuitable_domicile',
    'bearer_not_of_legal_age',
    'internal_error',
    'api_not_reachable',
    'document_type',
    'document_invalidated',
    'identification_stale',
    'document_expired',
    'visual_verification'
  ],
  SIGN_ERROR_CONCURRENT_MODIFICATION:
    'error.sign.document.concurrent.modification',
  PHONE_FIELD: {
    MAX_LENGTH: 25
  },
  PDF_PREVIEW: {
    WASM_URL: '/pdf/',
    ZOOM_STEPS_DEFAULT: [
      0.25, 0.33, 0.5, 0.67, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2, 2.5, 3,
      4
    ],
    MIN_ZOOM_DEFAULT: 0.25,
    MAX_ZOOM_DEFAULT: 4,
    A4_WIDTH_IN_PIXELS: 794 // A4 width in pixels at 96 DPI,
  },
  EMAIL_SERVICE: {
    MAX_COUNT_MEMBERS_TO_SHOW: 6,
    MAX_COUNT_RECENTLY_USED_EMAILS_TO_SHOW: 6,
    MAX_COUNT_RECENTLY_USED_EMAILS_TO_SAVE: 100
  },
  SIGNATURE_PREVIEW: {
    IMAGE_WITH_SIGNATURE: 190,
    IMAGE_WITH_SIGNATURE_TYPE_OPTIONAL_TEXT: 235,
    IMAGE_WITH_SIGNATURE_TYPE_OPTIONAL_TEXT_NAME: 294,
    IMAGE_WITH_ALL_PARAMS: 336
  }
};
